/**
 * Javascript file for the potential project partners page.
 * @author Yannik Sprengart, Andrea Villeda
 */

import auth from "../../../../auth";
import {
  getTechpartners,
  getCompanyProfile,
  getCompanies
} from "../../../../api";
export default {
  name: "Partners",

  /**
   * The vue instance's data object.
   * @property {string} companies - Result set of the recommended companies.
   * @property {any[]} searchresults - Result set of the potential partner search.
   * @property {string} msg - The platform's name.
   * @property {boolean} loading - Information is currently being loaded.
   * @property {boolean} trainer - Trainer status of the authorized profile.
   * @property {object} searchoptions - Search parameters for VueFuse. For more details, check: https://www.npmjs.com/package/vue-fuse/v/1.5.2
   */
  data() {
    return {
      companies: "",
      searchresults: [],
      msg: "WERNER",
      loading: false,
      trainer: auth.isTrainer(),
      searchterm: "",
      searchoptions: {
        shouldSort: true,
        threshold: 0.3,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 3,
        keys: ["name", "description"]
      }
    };
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Conducts a company search using this.searchterm as query.
     */
    search() {
      this.$search(this.searchterm, this.companies, this.searchoptions).then(
        results => {
          this.searchresults = results;
        }
      );
    },

    /**
     * Shortens the description.
     * @param {*} desc - The description.
     */
    shorten(desc) {
      if (desc) {
        var res = desc.substring(0, 500) + "...";
        return res;
      }
      return "";
    },

    /**
     * Returns to the previously visited page.
     */
    goBack() {
      this.$router.go(-1);
    }
  },

  /**
   * Expressions to watch.
   */
  watch: {
    searchterm: function() {
      if (this.searchterm === "") {
        this.searchresults = this.companies;
      } else {
        this.search();
      }
    }
  },

  /**
   * Called after the instance has been mounted.
   */
  mounted() {
    getCompanies()
      .then(res => {
        //console.log(res);
        this.companies = res.sort(function(a, b) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
        this.searchresults = res.sort(function(a, b) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      })
      .catch(err => {
        //console.log(err);
      });
  }
};



// WEBPACK FOOTER //
// ./src/components/company/profile/partners/partners.js